export const HHA_EXAM_ITEMS = [
    {
        id: "1",
        type: "multiple_choice",
        text: "The patients sometimes express religious beliefs with which the home health aide does not agree. In dealing with these situations, which of these understandings should the aide use as a guide?",
        options: [
            { label: "A", text: "Patients have a right to their own beliefs, which should be respected." },
            { label: "B", text: "Patients should be told not to discuss their beliefs with aides." },
            { label: "C", text: "Aides should explain their beliefs to the patients." },
            { label: "D", text: "Aides should pretend to have the same beliefs that the patients have." }
        ]
    },
    {
        id: "2",
        type: "multiple_choice",
        text: "Mrs. Wayne, a home health aide, leaves the home of Mr. Davis, a terminal ill patient. A neighbor stops her and says, 'Mr. Davis is very sick, isn't he? I hear he is near death.' What is it best for Mrs. Wayne to say?",
        options: [
            { label: "A", text: "“Yes, Mr. Davis is very ill.”" },
            { label: "B", text: "“How do you know Mr. Davis is so sick?”" },
            { label: "C", text: "“I’m sorry, I can’t discuss Mr. Davis.”" },
            { label: "D", text: "“Mr. Davis is doing as well as can be expected.”" }
        ]
    },
    {
        id: "3",
        type: "multiple_choice",
        text: "Miss Ferris, a home health aide, is assigned to care for Mr. Conway. Miss Ferris notices that she feels very angry when she is with Mr. Conway. What should Miss Ferris do because she feels this way?",
        options: [
            { label: "A", text: "Tell Mr. Conway how she is feeling." },
            { label: "B", text: "Find out if other aides have felt this way." },
            { label: "C", text: "Try to pretend that Mr. Conway is someone she likes." },
            { label: "D", text: "Talk with the agency supervisor about the situation." }
        ]
    },
    {
        id: "4",
        type: "multiple_choice",
        text: "A patient accuses a home health aide of stealing five dollars. The aide has not taken the patient's money, but the patient does not believe this. What should the aide do?",
        options: [
            { label: "A", text: "Ask the other aides who care for the patient if they took the five dollars." },
            { label: "B", text: "Ask the patient why the aide is being accused." },
            { label: "C", text: "Offer to give the patient five dollars." },
            { label: "D", text: "Notify the agency supervisor." }
        ]
    },
    {
        id: "5",
        type: "multiple_choice",
        text: "Which of these actions is the home health aide permitted to take in relation to drug administration?",
        options: [
            { label: "A", text: "Recording and reporting the patient’s reaction to the medication." },
            { label: "B", text: "Giving nonprescription medications whenever the patient asks for them." },
            { label: "C", text: "Adjusting the dosage of medications are given to the patient." },
            { label: "D", text: "Adjusting the times medications are given to fit into the patient’s activities schedule." }
        ]
    },
    {
        id: "6",
        type: "multiple_choice",
        text: "One morning shortly after the home health aide arrives, Mr. Walsh says, 'I have had cramping pains in the calf of my right leg for the last two hours.' In addition to reporting this complaint to the agency supervisor, what is the best way for the aide to write this on the chart?",
        options: [
            { label: "A", text: "“Complains of pain.”" },
            { label: "B", text: "“Right leg hurts.”" },
            { label: "C", text: "“States he has had cramping pains in the calf of his right leg for 2 hours.”" },
            { label: "D", text: "“Says he has leg cramps.”" }
        ]
    },
    {
        id: "7",
        type: "multiple_choice",
        text: "When a patient complains of pain, what should the home health aide do first?",
        options: [
            { label: "A", text: "Ask the patient to describe the pain." },
            { label: "B", text: "Call the patient’s doctor." },
            { label: "C", text: "Offer the patient some warm tea." },
            { label: "D", text: "Change the patient’s position." }
        ]
    },
    {
        id: "8",
        type: "multiple_choice",
        text: "A home health aide is assigned to a patient who is on a low-salt diet. Which of these items, if found in the patient’s refrigerator, should the aide suggest that the patient NOT eat?",
        options: [
            { label: "A", text: "Pickles" },
            { label: "B", text: "Carrots" },
            { label: "C", text: "Whole milk" },
            { label: "D", text: "Fresh fruit" }
        ]
    },
    {
        id: "9",
        type: "multiple_choice",
        text: "A patient is on a diabetic diet. Which of these foods should the patient NOT eat?",
        options: [
            { label: "A", text: "Baked fish" },
            { label: "B", text: "Apple pie" },
            { label: "C", text: "Green beans" },
            { label: "D", text: "Roast beef" }
        ]
    },
    {
        id: "10",
        type: "multiple_choice",
        text: "In the home, which of these is a safe method of thawing a package of frozen meat?",
        options: [
            { label: "A", text: "Leaving it on the kitchen counter for several hours." },
            { label: "B", text: "Placing it in the refrigerator overnight." },
            { label: "C", text: "Putting it in a pan of warm water." },
            { label: "D", text: "Placing it in the oven at a low temperature." }
        ]
    },
    {
        id: "11",
        type: "multiple_choice",
        text: "If a patient is to have a physical therapist visit the home, what should the home health aide do?",
        options: [
            { label: "A", text: "Carry out the therapist’s instructions between the therapist’s visits." },
            { label: "B", text: "Adjust the therapist’s equipment for the patient’s comfort." },
            { label: "C", text: "Write the notes about the therapy in the patient’s chart." },
            { label: "D", text: "Supervise the patient’s therapy exercises." }
        ]
    },
    {
        id: "12",
        type: "multiple_choice",
        text: "A patient has been given a list of exercises to do by a physical therapist. The patient tells the home health aide, 'I’m not doing these exercises today because they make me too tired.' What should the aide do?",
        options: [
            { label: "A", text: "Tell the patient that the exercises must be done anyway." },
            { label: "B", text: "Call the therapist to find out if the exercises are really necessary." },
            { label: "C", text: "Tell the patient it’s okay to skip them for one day." },
            { label: "D", text: "Report the patient’s refusal to the agency supervisor." }
        ]
    },
    {
        id: "13",
        type: "multiple_choice",
        text: "In order to help a patient be as independent as possible, what should the home health aide do?",
        options: [
            { label: "A", text: "Do everything for the patient." },
            { label: "B", text: "Help the patient only when it is absolutely necessary." },
            { label: "C", text: "Encourage the patient to do as much as possible." },
            { label: "D", text: "Follow the patient’s family’s instructions about care." }
        ]
    },
    {
        id: "14",
        type: "multiple_choice",
        text: "A patient’s care plan includes the goal 'Help patient remain active.' Which of these actions by the home health aide would best help to reach this goal?",
        options: [
            { label: "A", text: "Doing all the housework for the patient." },
            { label: "B", text: "Encouraging the patient to go for a walk every day." },
            { label: "C", text: "Watching television with the patient." },
            { label: "D", text: "Telling the patient to stay in bed and rest." }
        ]
    },
    {
        id: "15",
        type: "multiple_choice",
        text: "When a patient is being transferred from a bed to a wheelchair, what is the most important thing for the home health aide to do?",
        options: [
            { label: "A", text: "Lock the wheels on the wheelchair." },
            { label: "B", text: "Make sure the patient is wearing shoes." },
            { label: "C", text: "Place a pillow in the wheelchair." },
            { label: "D", text: "Tell the patient to hold on to the aide’s neck." }
        ]
    },
    {
        id: "16",
        type: "multiple_choice",
        text: "Which of these is the first sign of a pressure sore?",
        options: [
            { label: "A", text: "A break in the skin." },
            { label: "B", text: "Redness of the skin." },
            { label: "C", text: "Bleeding from the skin." },
            { label: "D", text: "Swelling of the skin." }
        ]
    },
    {
        id: "17",
        type: "multiple_choice",
        text: "To prevent pressure sores in a patient who must stay in bed, the home health aide should",
        options: [
            { label: "A", text: "Massage the patient’s legs every hour." },
            { label: "B", text: "Keep the patient’s skin clean and dry." },
            { label: "C", text: "Change the patient’s position every four hours." },
            { label: "D", text: "Use a plastic sheet on the bed." }
        ]
    },
    {
        id: "18",
        type: "multiple_choice",
        text: "The temperature that the arrow is pointing to should be recorded as:",
        image: "https://kornivus-hrms.s3.us-west-1.amazonaws.com/uploads/base/Screenshot+2026-02-22+at+3.39.50%E2%80%AFPM.png",
        options: [
            { label: "A", text: "99.8 F" },
            { label: "B", text: "100.6 F" },
            { label: "C", text: "103 F" },
            { label: "D", text: "106 F" }
        ]
    },
    {
        id: "19",
        type: "multiple_choice",
        text: "Which of these is the normal range for an adult's pulse rate?",
        options: [
            { label: "A", text: "40-60 beats per minute" },
            { label: "B", text: "60-100 beats per minute" },
            { label: "C", text: "100-120 beats per minute" },
            { label: "D", text: "120-140 beats per minute" }
        ]
    },
    {
        id: "20",
        type: "multiple_choice",
        text: "Why is the thumb NOT used for taking a patient’s pulse?",
        options: [
            { label: "A", text: "The flat part of thumb is less sensitive than the flat parts of other fingertips." },
            { label: "B", text: "The thumb can place too much pressure on the patient’s pulse." },
            { label: "C", text: "The thumb’s pulse may be felt instead of the patient’s pulse." },
            { label: "D", text: "The thumb’s tip is in a more awkward position than the other fingertips." }
        ]
    },
    {
        id: "21",
        type: "multiple_choice",
        text: "A patient’s pulse is to be taken for one full minute. If the home health aide counts 20 beats in 15 seconds, what is the pulse rate for one minute?",
        options: [
            { label: "A", text: "40" },
            { label: "B", text: "60" },
            { label: "C", text: "80" },
            { label: "D", text: "100" }
        ]
    },
    {
        id: "22",
        type: "multiple_choice",
        text: "The home health aide should count a patient’s respirations",
        options: [
            { label: "A", text: "After taking the pulse while still holding the patient's wrist." },
            { label: "B", text: "Before taking the temperature." },
            { label: "C", text: "After the patient has been walking." },
            { label: "D", text: "While the patient is talking." }
        ]
    },
    {
        id: "23",
        type: "multiple_choice",
        text: "When taking a patient’s blood pressure, the home health aide should",
        options: [
            { label: "A", text: "Apply the cuff to the patient’s bare arm." },
            { label: "B", text: "Place the stethoscope over the patient’s clothing." },
            { label: "C", text: "Inflate the cuff as much as possible." },
            { label: "D", text: "Deflate the cuff as quickly as possible." }
        ]
    },
    {
        id: "24",
        type: "multiple_choice",
        text: "A patient is to have a urine specimen collected for a 'clean-catch' test. What should the home health aide do?",
        options: [
            { label: "A", text: "Collect the urine at the beginning of the patient’s urination." },
            { label: "B", text: "Collect the urine in the middle of the patient’s urination." },
            { label: "C", text: "Collect the urine at the end of the patient’s urination." },
            { label: "D", text: "Collect all the urine the patient passes in 24 hours." }
        ]
    },
    {
        id: "25",
        type: "multiple_choice",
        text: "Which of these actions is NOT part of the home health aide’s role in helping a patient with a tub bath?",
        options: [
            { label: "A", text: "Testing the water temperature." },
            { label: "B", text: "Helping the patient in and out of the tub." },
            { label: "C", text: "Washing the patient’s hair." },
            { label: "D", text: "Cleaning the bathtub after use." }
        ]
    },
    {
        id: "26",
        type: "multiple_choice",
        text: "When giving a patient a bed bath, the home health aide should wash the patient’s body in what order?",
        options: [
            { label: "A", text: "Face, arms, trunk, legs, back, pubic area." },
            { label: "B", text: "Face, back, arms, trunk, legs, pubic area." },
            { label: "C", text: "Pubic area, legs, trunk, arms, back, face." },
            { label: "D", text: "Back, legs, trunk, arms, pubic area, face." }
        ]
    },
    {
        id: "27",
        type: "multiple_choice",
        text: "In giving foot care to a patient who has diabetes, the home health aide should NOT",
        options: [
            { label: "A", text: "Wash the feet with mild soap and water." },
            { label: "B", text: "Dry the feet carefully, especially between the toes." },
            { label: "C", text: "Cut the patient’s toenails." },
            { label: "D", text: "Look for any redness or sores on the feet." }
        ]
    },
    {
        id: "28",
        type: "multiple_choice",
        text: "A patient has an indwelling catheter. Which of these is part of the home health aide’s care for this patient?",
        options: [
            { label: "A", text: "Cleaning the area around the catheter with soap and water." },
            { label: "B", text: "Changing the catheter every week." },
            { label: "C", text: "Irrigating the catheter once a day." },
            { label: "D", text: "Removing the catheter when the patient goes to bed." }
        ]
    },
    {
        id: "29",
        type: "multiple_choice",
        text: "When helping a patient with a bedpan, the home health aide should",
        options: [
            { label: "A", text: "Leave the patient alone for 30 minutes." },
            { label: "B", text: "Place the bedpan in a chair next to the bed." },
            { label: "C", text: "Give the patient some privacy if it is safe to do so." },
            { label: "D", text: "Tell the patient to use the bedpan only once a day." }
        ]
    },
    {
        id: "30",
        type: "multiple_choice",
        text: "To help prevent the spread of infection, what is the most important thing for the home health aide to do?",
        options: [
            { label: "A", text: "Wear a mask at all times." },
            { label: "B", text: "Wash hands frequently." },
            { label: "C", text: "Keep the patient’s room very warm." },
            { label: "D", text: "Use only paper plates for the patient’s meals." }
        ]
    },
    {
        id: "31",
        type: "multiple_choice",
        text: "When working with persons who are disabled, the general goal of care is to",
        options: [
            { label: "A", text: "Provide constant supervision." },
            { label: "B", text: "Provide total care." },
            { label: "C", text: "Promote maximum self-care and independence within the limits of the person's ability." },
            { label: "D", text: "Promote the complete return of the person's abilities." }
        ]
    },
    {
        id: "32",
        type: "multiple_choice",
        text: "Mrs. S is a 75-year-old patient who has just returned home from the hospital after a stroke. She has some weakness in her right side. The home health aide should",
        options: [
            { label: "A", text: "Do everything for Mrs. S." },
            { label: "B", text: "Encourage Mrs. S to do as much as she can for herself." },
            { label: "C", text: "Tell Mrs. S to stay in bed until she is stronger." },
            { label: "D", text: "Tell Mrs. S that she will never be able to walk again." }
        ]
    },
    {
        id: "33",
        type: "multiple_choice",
        text: "Which of these is a symptom of infection?",
        options: [
            { label: "A", text: "Sudden onset of confusion." },
            { label: "B", text: "Redness, swelling, and warmth in an area." },
            { label: "C", text: "Increased appetite." },
            { label: "D", text: "A decrease in the pulse rate." }
        ]
    },
    {
        id: "34",
        type: "multiple_choice",
        text: "When caring for a patient who is dying, the home health aide should",
        options: [
            { label: "A", text: "Avoid talking to the patient about death." },
            { label: "B", text: "Provide comfort and support to the patient and family." },
            { label: "C", text: "Tell the patient that everything will be okay." },
            { label: "D", text: "Leave the patient alone as much as possible." }
        ]
    },
    {
        id: "35",
        type: "multiple_choice",
        text: "A patient has a communicable disease. The home health aide should",
        options: [
            { label: "A", text: "Wear gloves when in contact with the patient’s body fluids." },
            { label: "B", text: "Tell the neighbors about the patient’s disease." },
            { label: "C", text: "Refuse to care for the patient." },
            { label: "D", text: "Ask the patient’s family to provide all the care." }
        ]
    },
    {
        id: "36",
        type: "multiple_choice",
        text: "Which of these is a sign of dehydration?",
        options: [
            { label: "A", text: "Increased urination." },
            { label: "B", text: "Moist skin." },
            { label: "C", text: "Dark-colored urine." },
            { label: "D", text: "A slow pulse rate." }
        ]
    },
    {
        id: "37",
        type: "multiple_choice",
        text: "To prevent the patient from falling in the bathroom, the home health aide should suggest",
        options: [
            { label: "A", text: "Using a bath mat or non-skid strips in the tub." },
            { label: "B", text: "Keeping the bathroom floor waxed and shiny." },
            { label: "C", text: "Using a high-wattage light bulb in the bathroom." },
            { label: "D", text: "Having the patient take only sponge baths." }
        ]
    },
    {
        id: "38",
        type: "multiple_choice",
        text: "When helping a patient to walk with a cane, the home health aide should stand",
        options: [
            { label: "A", text: "On the patient’s strong side." },
            { label: "B", text: "On the patient’s weak side." },
            { label: "C", text: "In front of the patient." },
            { label: "D", text: "Behind the patient." }
        ]
    },
    {
        id: "39",
        type: "multiple_choice",
        text: "Mrs. Rand, who has Diabetes and takes Insulin regularly, tells the home health aide that she feels very nervous and jittery. What should the aide do immediately?",
        options: [
            { label: "A", text: "Take her temperature." },
            { label: "B", text: "Find out when she has her next doctor’s appointment." },
            { label: "C", text: "Have her lie down in bed." },
            { label: "D", text: "Give her a glass of orange juice." }
        ]
    },
    {
        id: "40",
        type: "multiple_choice",
        text: "If a patient is having a seizure, the home health aide should",
        options: [
            { label: "A", text: "Place a padded tongue blade in the patient’s mouth." },
            { label: "B", text: "Restrain the patient’s arms and legs." },
            { label: "C", text: "Move any objects away from the patient that could cause injury." },
            { label: "D", text: "Give the patient some water to drink." }
        ]
    },
    {
        id: "41",
        type: "multiple_choice",
        text: "Which of these is a rule of good body mechanics?",
        options: [
            { label: "A", text: "Bend from the waist when lifting." },
            { label: "B", text: "Keep the feet close together." },
            { label: "C", text: "Bend the knees and keep the back straight when lifting." },
            { label: "D", text: "Twist the body when moving a heavy object." }
        ]
    },
    {
        id: "42",
        type: "multiple_choice",
        text: "A patient’s kitchen is very cluttered and has many extension cords across the floor. The home health aide should",
        options: [
            { label: "A", text: "Tell the patient that the kitchen is a fire hazard." },
            { label: "B", text: "Suggest that the extension cords be removed or taped down." },
            { label: "C", text: "Ignore the situation since it is the patient's home." },
            { label: "D", text: "Refuse to work in the kitchen." }
        ]
    },
    {
        id: "43",
        type: "multiple_choice",
        text: "If a home health aide finds a patient unconscious on the floor, what should the aide do first?",
        options: [
            { label: "A", text: "Call the agency supervisor." },
            { label: "B", text: "Check the patient’s pulse and breathing." },
            { label: "C", text: "Move the patient to the bed." },
            { label: "D", text: "Give the patient some water." }
        ]
    },
    {
        id: "44",
        type: "multiple_choice",
        text: "When a patient is confused, the home health aide should",
        options: [
            { label: "A", text: "Argue with the patient to show them they are wrong." },
            { label: "B", text: "Give the patient many choices to make." },
            { label: "C", text: "Use simple sentences and speak clearly." },
            { label: "D", text: "Avoid talking to the patient." }
        ]
    },
    {
        id: "45",
        type: "multiple_choice",
        text: "Which of these is a common side effect of many medications?",
        options: [
            { label: "A", text: "Increased energy." },
            { label: "B", text: "Dizziness or drowsiness." },
            { label: "C", text: "Improved memory." },
            { label: "D", text: "A decrease in appetite." }
        ]
    },
    {
        id: "46",
        type: "multiple_choice",
        text: "If a patient becomes angry and starts shouting at the home health aide, the aide should",
        options: [
            { label: "A", text: "Shout back at the patient." },
            { label: "B", text: "Leave the house immediately." },
            { label: "C", text: "Stay calm and listen to the patient." },
            { label: "D", text: "Tell the patient they are being rude." }
        ]
    },
    {
        id: "47",
        type: "multiple_choice",
        text: "A home health aide is assigned to a patient who has a hearing loss. The aide should",
        options: [
            { label: "A", text: "Shout as loudly as possible." },
            { label: "B", text: "Face the patient when speaking." },
            { label: "C", text: "Avoid talking to the patient." },
            { label: "D", text: "Speak into the patient’s ear." }
        ]
    },
    {
        id: "48",
        type: "multiple_choice",
        text: "Before trying first aid measures for a patient who is choking on food or some other object stuck in the airway, what should the home health aide find out?",
        options: [
            { label: "A", text: "Can the patient speak or cough?" },
            { label: "B", text: "Can the patient swallow clear fluids?" },
            { label: "C", text: "Has the patient taken any sedatives within the last hour?" },
            { label: "D", text: "Does the patient have a pulse rate over 70?" }
        ]
    },
    {
        id: "49",
        type: "multiple_choice",
        text: "Which of the following is the best way to help a patient who is having a fainting spell?",
        options: [
            { label: "A", text: "Lower the patient to the floor and elevate the patient's legs." },
            { label: "B", text: "Help the patient into a chair and put the patient's head between the knees." },
            { label: "C", text: "Have the patient stand up and walk around." },
            { label: "D", text: "Give the patient a glass of water to drink." }
        ]
    },
    {
        id: "50",
        type: "multiple_choice",
        text: "Which of these is a sign of a stroke?",
        options: [
            { label: "A", text: "Sudden onset of a high fever." },
            { label: "B", text: "Sudden weakness or numbness on one side of the body." },
            { label: "C", text: "A decrease in the patient's appetite." },
            { label: "D", text: "Pain in the patient's lower back." }
        ]
    }
];
